export interface DataTableStateModel { 
  sortingValue: {
    prop: string,
    dir: string
  };
  pageNumber: number;
  showItemsPerPage: number;
  gridName: string;
  tableType: string;
  datatableFilters?: DataTableColumnFiltersApi[];
  datatableColumns?: DataTableColumnModel[];
  datatableFilterName?: string;
  datatableFilterIsGlobal?: boolean;
  datatableFilterId?: number;
}

export interface DataTableStateApiModel { 
  dashboardType?: string;
  orderField:string;
  skipCount: number;
  takeCount:number;
  isOrderByDescending: boolean | string;
}

export interface DataTableColumnModel { 
  name: string;
  prop: string;
  selectFieldKey?: string;
  frozenLeft?: boolean;
  frozenRight?: boolean;
  flexGrow?: number;
  resizeable?: boolean;
  highlightValue?: true;
  sortable?: boolean;
  draggable?: boolean;
  minWidth?: number;
  width?: number;
  maxWidth?: number;
  headerClass?: string;
  cellClass?: string;
  hasFilter?: boolean;
  linkedValue?: boolean;
  richText?: boolean;
  icon?: string;
  fieldType?: string;
  dateFormat?: string;
  actionButtons?: {
    save?: boolean,
    delete?: boolean,
    discardChanges?: boolean,
    impersonate?: boolean,
  }
  inlineEditingConfig?: DataTableInlineEditingConfigModel;
  dataTableColumnFilters?: DataTableColumnFilters[];
  isColumnFilterActive?: boolean;
  showFilterSearch?: boolean;
  showColumn?: boolean;
}

export interface DataTableInlineEditingConfigModel { 
  field: string;
  type?: string;
  placeholder?: string;
  cellPlaceholder?: string;
  selectConfig?: {
    isRelatedField?: boolean;
    bindLabel?: string;
    bindValue?: string;
    clearable?: boolean;
    searchable?: boolean;
    items?: any,
    addTagText?: string,
    addTag?: boolean,
    addSelectedItem?: Object;
  }
}

export interface DataTableColumnFilters { 
  name: string;
  value: string;
}

export interface DataTableColumnFiltersApi { 
  columnName?: string; 
  columnSelectedValues?: Array<string> | null;
  columnSearchValue?: string | null;
  displayName?: string;
  columnDateTimeRangeValues?: { from: string | null; to: string | null } | null;
}

export interface DataTableConfigSettings { 
  gridType: string;
  gridFilterSettings: string;
  gridColumnSettings: string;
  id?: number;
  name?: string;
}

export enum DataTableSortEnum { 
  SORT_ASC = 'asc',
  SORT_DESC = 'desc',
}

export enum DataTableEventsEnum { 
  CHANGE_PAGE = 'chagePage',
  CHANGE_ITEMS_PER_PAGE = 'itemsPerPage',
}

export enum DataTableItemsPerPageEnum { 
  ITEMS_PER_PAGE_10 = 10,
  ITEMS_PER_PAGE_20 = 20,
  ITEMS_PER_PAGE_50 = 50,
  ITEMS_PER_PAGE_100 = 100
}

export enum DataTableInlineEditingConfigEnum { 
  INPUT_FIELD =  'input',
  SELECT_FIELD =  'select',
  INPUT_TYPE_TEXT = 'text',
  INPUT_TYPE_NUMBER = 'number',
}

export enum DataTableActionEnum { 
  SAVE = 'save',
  DELETE = 'delete',
  DISCARD_CHANGES = 'discardChanges',
  IMPERSONATE = "impersonate"
}

export enum DataTableSortBooleanEnum { 
  TRUE = 'true',
  FALSE = 'false',
}
